// src/LandingPage.jsx
// import React, { useState } from "react";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import ForgotPasswordModal from "./components/ForgotPasswordModal";
import Toast from "./components/Toast";

function LandingPage() {
  const { user, authLoading, signUp, signIn, signOutUser, resetPassword } = useAuth();
  const [mode, setMode] = useState("login"); // "login" | "signup"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authError, setAuthError] = useState("");
  const [authMessage, setAuthMessage] = useState("");
  const [contactMessage, setContactMessage] = useState("");
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState("");
  const navigate = useNavigate();
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [infoModal, setInfoModal] = useState(null); // values: null | "about" | "transparency"


useEffect(() => {
  const handleScroll = () => {
    setShowBackToTop(window.scrollY > 300);
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);


  const handleAuthSubmit = async (e) => {
    e.preventDefault();
    setAuthError("");
    setAuthMessage("");

    try {
      if (mode === "signup") {
        const newUser = await signUp(email, password);
        setAuthMessage(
          "Account created. Check your email for a verification link before using the app."
        );

     } else {
  await signIn(email, password);
  setAuthMessage("Logged in successfully.");

  // 🔥 Auto-redirect after login
  setTimeout(() => {
    navigate("/app");
  }, 700);
}


   } catch (err) {
  console.error(err);

  let friendlyMessage = "Incorrect email or password.";

  if (err.code === "auth/email-already-in-use") {
    friendlyMessage =
      "This email is already registered. Please log in or use a different email.";
  } else if (err.code === "auth/invalid-email") {
    friendlyMessage = "Please enter a valid email address.";
  } else if (err.code === "auth/weak-password") {
    friendlyMessage = "Password must be at least 6 characters long.";
  } else if (err.code === "auth/user-not-found") {
    friendlyMessage = "No account found with this email. Please sign up first.";
  } else if (err.code === "auth/wrong-password") {
    friendlyMessage = "Incorrect password. Please try again.";
  }

  setAuthError(friendlyMessage);
   }

 };

  const goToApp = () => {
    if (!user) {
      setAuthError("Please log in first.");
      return;
    }
    if (!user.emailVerified) {
      setAuthError("Please verify your email before launching the app.");
      return;
    }
    navigate("/app");
  };

 const handleContactSubmit = async (e) => {
  e.preventDefault();

  const form = e.target;
  const name = form.name.value;
  const email = form.email.value;
  const message = form.message.value;

  try {
    const res = await fetch(
      "https://us-central1-newaar-d8c9e.cloudfunctions.net/sendFeedback",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          message,
        }),
      }
    );

    const data = await res.json();

    if (!res.ok || !data.success) {
      throw new Error("Failed to send feedback");
    }

    setContactMessage("Thanks for your feedback! It’s been sent successfully.");
    form.reset();
  } catch (err) {
    console.error("Feedback error:", err);
    setContactMessage(
      "Sorry — something went wrong. Please try again in a moment."
    );
  }
};


    const handleForgotPasswordSubmit = async (email) => {
  if (!email || email.trim() === "") {
    setToastMsg("Please enter your email first.");
    setToastType("error");
    setTimeout(() => setToastMsg(""), 3000);
    return;
  }

  try {
    await resetPassword(email);
    setToastMsg("Reset email sent — check your inbox!");
    setToastType("success");
    setShowForgotModal(false);
    setTimeout(() => setToastMsg(""), 3000);
  } catch (err) {
    setToastMsg(err.message || "Failed to send reset email.");
    setToastType("error");
    setTimeout(() => setToastMsg(""), 3000);
  }
};




  return (
    <div className="landing-root">
      {/* Re-use your cyber neon background */}
      <div className="background-particles" />

      {/* NAVBAR */}
      <header className="landing-navbar">
        <div className="logo-wrapper">
          <span className="logo-scanline" />
          <img src="/badger.png" className="badger-logo" alt="logo" />
          <span className="landing-brand neon-title">MultiVersal Blockchain Tracer</span>

 </div>

        <div className="landing-nav-right">
          {authLoading ? (
            <span className="landing-user-chip neon-title">
Checking session...</span>
          ) : user ? (
            <>
              <span className="landing-user-chip">
                {user.email}{" "}
                {!user.emailVerified && (
                  <span className="not-verified">Verified? Press Refresh ➜</span>
                )}
              </span>
              <button className="landing-ghost-btn" onClick={signOutUser}>
                Refresh
              </button>
            </>
          ) : null}
        </div>
      </header>

      {/* HERO SECTION */}                                                                                      

      <section className="hero-section">
        <div className="hero-left glass-card">

<h1 className="text-4xl font-bold">
  AI-Powered Wallet Intelligence & Risk Reporting Across Chains.
</h1>
          <p className="hero-tagline">
            Fully anonymous. Cross-chain. Clear, actionable insights.
          </p>

          <ul className="hero-bullets">
            <li>🤖 AI-powered wallet intelligence — exposure, trends, volatility, and risk signals.</li>
            <li>📈 Cross-chain portfolio clarity — unified insights across major blockchains.</li>
            <li>🛡️ Wallet diagnostics — detects common visibility issues and pending transactions.</li>
            <li>🔒 Privacy-first by design — no wallet connection, no tracking, fully anonymous.</li>
          </ul>

          <div className="hero-cta-row">

  <button className="landing-primary-btn" onClick={goToApp}>
    Launch App
  </button>

  <button
    className="landing-secondary-btn"
    onClick={() =>
      document.getElementById("how-it-works")
        .scrollIntoView({ behavior: "smooth" })
    }
  >
    How it works
  </button>

  <button
    className="landing-secondary-btn"
    onClick={() =>
      document.getElementById("why-it-matters")
        .scrollIntoView({ behavior: "smooth" })
    }
  >
    Why This dApp Matters
  </button>

  <button
    className="landing-secondary-btn"
    onClick={() =>
      document.getElementById("vision-mission")
        .scrollIntoView({ behavior: "smooth" })
    }
  >
    Our Vision & Mission
  </button>
</div>


          <p className="hero-note">
            Free users get limited daily scans. Verify your email to keep your access secure.<br />
            Read-only analysis of public blockchain data — this app never initiates transactions or interacts with funds.
          </p>
        </div>

        {/* AUTH PANEL */}
        <div className="hero-right glass-card">
          <h2>{mode === "signup" ? "Create your free account" : "Welcome back"}</h2>

          <div className="auth-toggle">
            <button
              className={mode === "login" ? "auth-tab active" : "auth-tab"}
              onClick={() => setMode("login")}
            >
              Log In
            </button>
            <button
              className={mode === "signup" ? "auth-tab active" : "auth-tab"}
              onClick={() => setMode("signup")}
            >
              Sign Up
            </button>
          </div>

          <form className="auth-form" onSubmit={handleAuthSubmit}>
            <label>
              Email
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email address"
              />
            </label>

            <label>
              Password
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
              />
            </label>

<button
  type="button"
  className="forgot-password-btn"
  onClick={() => setShowForgotModal(true)}
>
  Forgot Password?
</button>

	      <button className="landing-primary-btn" type="submit" disabled={authLoading}>
              {mode === "signup" ? "Sign Up & Send Code" : "Log In"}
            </button>
          </form>

          {authError && <p className="auth-error">{authError}</p>}
          

          {user && !user.emailVerified && (
            <p className="verify-hint">
              We’ve sent a verification link to your email.<br />
              After verifying, click <strong>Refresh →</strong> to continue.<br />
              Account setup may take a few minutes.
            </p>
          )}
        </div>
      </section>

      {/* TWO-COLUMN LAYOUT: How It Works + dApp Preview */}
<div className="landing-two-col">

 {/* LEFT COLUMN — HOW IT WORKS + BLOCKCHAIN BASICS */}
<section id="how-it-works" className="landing-section glass-card landing-col">

  {/* Main Title */}
  <h2 className="neon-title">How this dApp Works (Decentralized Application)</h2>

  <div className="how-grid">
    <div>
      <h3>1. Paste a wallet address</h3>
      <p>
        Enter any public wallet address or ENS name. No wallet connection needed.
      </p>
    </div>

    <div>
      <h3>2. We scan multiple chains</h3>
      <p>
        Ethereum, Polygon, Arbitrum, BNB, Optimism, Base & Avalanche.
      </p>
    </div>

    <div>
      <h3>3. We build insights</h3>
      <p>
        Portfolio pie charts + 30-day sparkline trends per token.
      </p>
    </div>

    <div>
      <h3>4. SmartInsight recommendations</h3>
      <p>
        Trend, stability, and portfolio share scoring (not financial advice).
      </p>
    </div>
  </div>

  {/* Divider Line (Soft Neon) */}
  <hr style={{
    margin: "2rem 0",
    border: "none",
    height: "1px",
    background: "rgba(0,255,255,0.2)"
  }} />

  {/* SECOND SECTION — Blockchain Basics */}

 {/* Anchor for Explore link */}
<div id="blockchain-basics" className="section-anchor" />

<h2 className="neon-title">
  Blockchain Basics & Wallet Fundamentals
</h2>


  <div className="how-grid">
    <div>
      <h3>What is a blockchain?</h3>
      <p>
        A blockchain is a public, decentralized ledger where all activity is transparent
        and verifiable. No single authority controls it.
      </p>
    </div>

    <div>
      <h3>What is a wallet address?</h3>
      <p>
        A wallet address is your public identifier — similar to a bank account number.
        Anyone can send funds to it, but only you can access them.
      </p>
    </div>

    <div>
      <h3>Why are wallet addresses public?</h3>
      <p>
        Transparency is fundamental to blockchain. Balances & transactions are public,
        which allows scanners like this dApp to analyze activity.
      </p>
    </div>

    <div>
      <h3>What is ENS?</h3>
      <p>
        ENS (Ethereum Name Service) converts long wallet addresses into names such as
        <strong> vitalik.eth</strong>. Each ENS name points to an Ethereum address.
      </p>
    </div>

    <div>
      <h3>How this dApp can look up ENS and addresses</h3>
      <p>
        ENS names resolve to public wallet addresses. Since balances are public on-chain,
        this dApp can fetch and display wallet tokens for either format.
      </p>
    </div>

 <div>
      <h3>What is a dApp?</h3>
      <p>
        A dApp (Decentralized Application) is software that runs on a blockchain instead of centralized servers, using smart contracts to operate without intermediaries.
      </p>
    </div>
  </div>


</section>


 {/* RIGHT COLUMN — dApp PREVIEW */}
<section className="landing-section glass-card landing-col">
  <h2 className="neon-title">dApp Preview</h2>
  <p className="section-subtitle">
    A quick look at the MultiVersal Blockchain Tracer in action.
  </p>

  <div className="screenshot-row">

    {/* Screenshot 1 — Wallet Overview */}
    <div className="screenshot-item">
      <img src="/wallet-overview.png" alt="Wallet Overview" />
      <p className="caption">Per-Chain Wallet Scan Results Breakdown</p>
    </div>

    {/* Screenshot 2 — SmartInsight Token Recommendations */}
    <div className="screenshot-item">
      <img src="/smartinsight-tokens.png" alt="SmartInsight Tokens" />
      <p className="caption">SmartInsight Token Recommendations</p>
    </div>

    {/* Screenshot 3 — Top Recommendations (NEW) */}
    <div className="screenshot-item">
      <img src="/top-recommendations.png" alt="Top Recommendations" />
      <p className="caption">Top Portfolio-Based Token Scores</p>
    </div>

  </div>
</section>

</div>
{/* WHY THIS dApp MATTERS */}
<section id="why-it-matters" className="landing-section glass-card">
  <h2 className="neon-title">Why This dApp Matters</h2>

  <p className="section-subtitle">
    This isn’t just another dashboard — it’s an intelligence layer for on-chain assets.
MultiVersal Blockchain Tracer exists to bring clarity, trust, and structure to an increasingly fragmented blockchain ecosystem.
  </p>

  <div className="value-grid">

    <div>
      <h3>If this dApp disappeared tomorrow…</h3>
      <p>
        Users would lose a neutral, privacy-first source of truth for understanding wallets across multiple blockchains.
        No wallet connections. No biased incentives. Just clean, unified visibility across Ethereum, Polygon, Arbitrum, BNB,          Optimism, Base, and Avalanche.
      </p>
    </div>

    <div>
      <h3>What makes it a standard?</h3>
      <p>
        <strong>Privacy-first architecture</strong> — address-based analysis with no wallet connection
        <br /><br />
        <strong>Consistent cross-chain intelligence</strong> — the same signals, metrics, and outputs across all      supported networks
        <br /><br />
        <strong>Trusted data foundations</strong> — powered by Covalent and CoinGecko
        <br /><br />
        <strong>Built for reliability</strong> — stable interfaces, predictable output, transparent design
        <br /><br />
        This is infrastructure you can rely on — every time.
      </p>
    </div>
    
    <div>
      <h3>The problem it solves</h3>
      <p>
        Blockchain data is fragmented, noisy, and often locked behind wallet permissions.
        Most tools show data — very few provide understanding.<br /><br />
        MultiVersal unifies balances, historical trends, allocation, volatility, and risk signals into a single, readable   overview, without compromising privacy.
      </p>
    </div>

    <div>
      <h3>What it does for you</h3>
      <p>
        Saves hours of manual research. Reveals true multi-chain exposure. Highlights risk, concentration, and trends. 
        Turns raw on-chain data into actionable insight.<br /><br />
        Whether you’re a user, analyst, or platform, the result is the same:
        faster clarity and better decisions.
      </p>
    </div>

  </div>
</section>
{/* RIGHT — Famous Wallets Card */}
<div
  id="wallet-samples"
  className="landing-section glass-card landing-col wallet-samples-card"
>


  <h2 className="neon-title">Try These Public Wallets</h2>

  <p className="wallet-samples-sub">
    See how <strong> AI-powered wallet intelligence </strong> works in real time — no wallet connection required.<br /><br />

    These are <strong> well-known, publicly visible wallets </strong> you can use to explore how MultiVersal analyzes exposure, trends,  allocation, and risk across chains.<br /><br />

    Just copy one address or ENS name, paste it into the <strong> Enter Wallet Address field </strong>, and <strong> click View Wallet. </strong>
  </p>

  <div className="wallet-samples-group">
    <h4>.eth Names</h4>
    <ul>
      <li>vitalik.eth</li>
      <li>ens.eth</li>
      <li>foundation.eth</li>
      <li>Meta.eth</li>
      <li>Microsoft.eth</li>
    </ul>
  </div>

  <div className="wallet-samples-group">
    <h4>Public Addresses</h4>
    <ul className="wallet-address-list">
      <li>0xd8dA6BF26964aF9D7eEd9e03E53415D37aA96045</li>
      <li>0x28C6c06298d514Db089934071355E5743bf21d60</li>
      <li>0x742d35Cc6634C0532925a3b844Bc454e4438f44e</li>
    </ul>
  </div>

  <p className="wallet-samples-note">
     - See how the AI detects concentration, allocation and observe cross-chain exposure<br /><br />
     - Explore 30-day trends, volatility, and risk signals<br /><br />
     - Understand how insights scale from simple to complex portfolios<br /><br />
     <strong>"This is the fastest way to understand what the platform does."</strong>
  </p>

</div>

<section id="vision-mission" className="landing-section glass-card">
  <h2 className="neon-title">Our Vision & Mission</h2>

  <div className="vm-wrapper">

    {/* Vision */}
    <div className="vm-box">
      <h3 className="vm-heading">Vision</h3>
      <p>
        To empower anyone to see the blockchain for themselves — transparently, securely, and without barriers.                        We believe Web3 should be understandable, not obscured by complexity.<br /><br />
        Our platform serves as a clear lens into on-chain activity, where balances, wallets, and risk are revealed with clarity — and trust is built not on promises, but on what users can verify for themselves.

      </p>
      <p className="vm-sub">— “Transparency you don’t have to take on faith.”</p>
    </div>

    {/* Mission */}
    <div className="vm-box">
      <h3 className="vm-heading">Mission</h3>
      <p>
        Our mission is to make blockchain transparency accessible by delivering a simple, secure, and privacy-first intelligence platform.<br /><br />

        We enable users to analyze wallets, understand cross-chain exposure, and identify risk signals — without wallet connections or intermediaries.<br /><br />

        By combining trusted data, consistent insights, and user-first design, we set a higher standard for clarity and trust in Web3.
      </p>
      <p className="vm-sub">— “See it. Verify it. Own it.”</p>
    </div>

  </div>
</section>

      {/* CONTACT / FEEDBACK */}
<section
  id="contact-feedback"
  className="landing-section glass-card"
>
  <h2>Contact & Feedback</h2>

  <p className="section-subtitle">
    Found a bug, have a feature idea, or want to collaborate?
    Email us directly.
  </p>

  <div className="feedback-actions">
    {/* SEND FEEDBACK (opens email client) */}
 <a
  href="mailto:Feedback@MultiVersalTracer.com?subject=Feedback for MultiVersal Tracer&body=Hi,%0D%0A%0D%0APlease write your feedback here:%0D%0A"
  className="landing-primary-btn"
  style={{ display: "inline-block", textDecoration: "none" }}
>
  Send Feedback
</a>

    {/* EMAIL DISPLAY */}
    <p style={{ marginTop: "1.25rem" }}>
      Or email us at:
      <br />
      <strong>
       <a
  href="mailto:Feedback@MultiVersalTracer.com"
  style={{
    color: "#00ffff",          // cyan
    textDecoration: "none",
    fontWeight: 500,
  }}
>
  Feedback@MultiVersalTracer.com
</a>

      </strong>
    </p>

    {/* COPY EMAIL */}
    <button
      className="landing-secondary-btn"
      style={{ marginTop: "0.75rem" }}
      onClick={() => {
        navigator.clipboard.writeText("Feedback@MultiVersalTracer.com");
        setToastMsg("Email copied to clipboard");
        setToastType("success");
        setTimeout(() => setToastMsg(""), 2500);
      }}
    >
      Copy Email
    </button>
  </div>
</section>

     {/* PLATFORM OVERVIEW & CREDITS */}
<section className="landing-section glass-card platform-info-card">
  <h2 className="neon-title">Platform Overview & Credits</h2>

  <div className="platform-info-grid">

{/* ABOUT */}
<div className="platform-col">
  <h3>About</h3>
  <ul>
    <li>
      <button className="link-btn" onClick={() => setInfoModal("about")}>
        What is MultiVersal Tracer
      </button>
    </li>
    <li>
      <button className="link-btn" onClick={() => setInfoModal("about")}>
        How it works
      </button>
    </li>
    <li>
      <button className="link-btn" onClick={() => setInfoModal("about")}>
        Supported chains
      </button>
    </li>
    <li>
      <button className="link-btn" onClick={() => setInfoModal("about")}>
        About us
      </button>
    </li>
  </ul>
</div>


{/* TRANSPARENCY */}
<div className="platform-col">
  <h3>Transparency</h3>
  <ul>
    <li>
      <button className="link-btn" onClick={() => setInfoModal("transparency")}>
        Privacy first
      </button>
    </li>
    <li>
      <button className="link-btn" onClick={() => setInfoModal("transparency")}>
        Responsible use
      </button>
    </li>
    <li>
      <button className="link-btn" onClick={() => setInfoModal("transparency")}>
        Data sources
      </button>
    </li>
  </ul>
</div>



{/* EXPLORE */}
<div className="platform-col">
  <h3>Explore</h3>
  <ul>
    <li>
      <a href="#contact-feedback">Contact & feedback</a>
    </li>
    <li>
      <a href="#vision-mission">Our vision & mission</a>
    </li>
    <li>
      <a href="#wallet-samples">Try these famous wallets</a>
    </li>
    <li>
      <a href="#why-it-matters">Why this dApp matters</a>
    </li>
    <li>
      <a href="#blockchain-basics">Blockchain basics & wallet fundamentals</a>
    </li>
  </ul>
   </div>

{/* SUPPORT */}
<div className="platform-col">
  <h3>Support</h3>
  <ul>
    <li>
      <span className="support-label">Support email</span>
      <div className="support-email-row">
        <code className="support-email">
          Support@MultiVersalTracer.com
        </code>
        <button
  className="copy-support-btn"
  onClick={() => {
    navigator.clipboard.writeText("Support@MultiVersalTracer.com");
    setToastMsg("Support email copied to clipboard");
    setToastType("success");
    setTimeout(() => setToastMsg(""), 2500);
  }}
>
  Copy
</button>

      </div>
    </li>

    <li className="support-note">
      For account help, security concerns, or bug reports, email us anytime.
    </li>
  </ul>
</div>


  </div>

  {/* Divider */}
  <hr className="platform-divider" />

 {/* BRAND SIGNATURE */}
<div className="platform-signature">
  <h3 className="signature-title">MultiVersal Blockchain Tracer</h3>
  <p className="signature-tagline">
    "A new dimension of blockchain clarity"
  </p>
</div>

{/* ACKNOWLEDGMENTS */}
<div className="platform-acknowledgments">
  <p>
    <strong>Data:</strong> Covalent &amp; CoinGecko
  </p>
  <p>
    <strong>SmartInsight:</strong> Custom logic &amp; AI-inspired analysis
  </p>
</div>

  {/* LEGAL LINKS */}
  <div className="platform-legal-links">
    <a href="/about" target="_blank" rel="noopener noreferrer">
      About &amp; Transparency
    </a>
    <span> · </span>
    <a href="/privacy" target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </a>
    <span> · </span>
    <a href="/terms" target="_blank" rel="noopener noreferrer">
      Terms of Use
    </a>
  </div>
</section>

{showBackToTop && (
  <button
    className="back-to-top-btn"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    aria-label="Back to top"
  >
    ↑ Top
  </button>
)}
<footer className="footer">
  <p>© {new Date().getFullYear()} Erling Garcia &amp; Son · Built in Canada 🍁</p>
</footer>

<ForgotPasswordModal
  open={showForgotModal}
  onClose={() => setShowForgotModal(false)}
  onReset={handleForgotPasswordSubmit}
/>

{infoModal && (
  <div className="fp-overlay" onClick={() => setInfoModal(null)}>
    <div className="fp-modal glass-card" onClick={(e) => e.stopPropagation()}>
      
      {infoModal === "about" && (
        <>
          <h2 className="fp-title">About MultiVersal Tracer</h2>
          <p className="fp-sub">
            MultiVersal Blockchain Tracer is a privacy-first, multi-chain
            wallet analysis dashboard.
          </p>

          <ul className="modal-list">
            <li>🔍 Scan wallets without connecting</li>
            <li>🌐 Ethereum, Polygon, Arbitrum, BNB, Optimism, Base, Avalanche</li>
            <li>📊 Token trends & portfolio insights</li>
            <li>🕵️ Fully anonymous by design</li>
          </ul>
        </>
      )}

      {infoModal === "transparency" && (
        <>
          <h2 className="fp-title">Transparency & Trust</h2>
          <p className="fp-sub">
            This platform is built to respect user privacy and data integrity.
          </p>

          <ul className="modal-list">
            <li>🔐 No wallet connections</li>
            <li>📡 Read-only blockchain data</li>
            <li>📊 Data from Covalent & CoinGecko</li>
            <li>⚖️ No financial advice or custody</li>
          </ul>
        </>
      )}

      <button className="modal-secondary-btn" onClick={() => setInfoModal(null)}>
        Close
      </button>
    </div>
  </div>
)}


<Toast message={toastMsg} type={toastType} />

    </div>
  );
}

export default LandingPage;
